import { NSARouterMakerResult } from "namirasoft-account-react";
import { KnowledgebaseInputRow, KnowledgebaseRow } from "namirasoft-inference";
import { NSBox, NSBoxString, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseEditPageProps extends NSARouterMakerResult, InferenceRouterProps
{
    isEdit: boolean;
}

export default class KnowledgebaseEditPage extends Component<KnowledgebaseEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxString_Description = createRef<NSBoxString>();

    override render()
    {
        return (
            <InferenceLayout<KnowledgebaseRow, KnowledgebaseInputRow>
                {...this.props}
                action={{ description: this.props.isEdit ? InferenceInfo.knowledgebase.edit : InferenceInfo.knowledgebase.create }}
                pages={{
                    entity: InferenceEntities.knowledgebase(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): KnowledgebaseInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let description = this.NSBoxString_Description.current?.getValue() ?? null;
                                        return {
                                            workspace_id: null,
                                            name,
                                            description,
                                            knowledgebase_category: [],
                                            knowledgebase_field: [],
                                            knowledgebase_tag: [],
                                        };
                                    },
                                    setRow: (row: KnowledgebaseRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxString_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-name" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-description" }}
                    />
                </NSColumn>
            </InferenceLayout>
        );
    }
}